
import { computed, defineComponent, PropType } from 'vue'

type Option = { id: number; name: string }

export default defineComponent({
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledOptionsIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        value: {
            type: Array as PropType<number[]>,
            default: () => []
        },
        options: {
            type: Array as PropType<Option[]>,
            default: () => []
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const isOptionDisabled = (option: Option) => {
            return props.disabledOptionsIds.includes(option.id)
        }

        const isOptionSelected = (option: Option) => {
            return props.value.includes(option.id)
        }

        const onClick = (option: Option) => {
            if (props.disabled) return
            if (isOptionDisabled(option)) return
            
            if (isOptionSelected(option)) {
                const index = props.value.findIndex((option_id) => option_id === option.id)

                if (index >= 0) {
                    const arr_copy = [...props.value]
                    arr_copy.splice(index, 1)

                    emit('update:value', arr_copy)
                    emit('change', arr_copy)
                }

                return
            }

            const arr_copy = [...props.value]
            arr_copy.push(option.id)

            emit('update:value', arr_copy)
            emit('change', arr_copy)
        }

        const typeSwitcherClasses = computed(() => {
            return {
                'TypeSwitcher--selected': props.options.every(isOptionSelected),
                'disabled': props.disabled,
            }
        })

        return {
            isOptionDisabled,
            isOptionSelected,
            onClick,
            typeSwitcherClasses
        }
    }
})
